import { render, staticRenderFns } from "./dianLiFenXi.vue?vue&type=template&id=69645454&scoped=true&"
import script from "./dianLiFenXi.vue?vue&type=script&lang=js&"
export * from "./dianLiFenXi.vue?vue&type=script&lang=js&"
import style0 from "./dianLiFenXi.vue?vue&type=style&index=0&id=69645454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69645454",
  null
  
)

export default component.exports